import {Injectable} from '@angular/core'
import {HttpService} from './_.http-mock'
import {Form} from '../model'
import {Observable, of} from 'rxjs'
import {map} from 'rxjs/operators'
import {MessageService} from '../service/message.service'
import {ConfigService} from '../service/config.service'
import {formStorage} from '../../../../form-editor-demo/src/app/core/persistance/local-storage'

@Injectable()
export class FormHttp {

  constructor(private config: ConfigService,
              private message: MessageService,
              private http: HttpService) {
  }

  get(): Observable<Form> {
    const form = formStorage.load()
    if (form) return of(form)
    return this.http.get(`form/${this.config.get().formId}`).pipe(map(f => {
      if (f.sections.length === 0) return buildDefaultForm(f.id)
      return f
    }))
  }

  getPossibilitiesWeights(): string[] {
    return this.config.get().weights
  }
}

const buildDefaultForm = (id: string): Form => {
  return <Form> {
    'id': id,
    'name': '',
    'description': '',
    'sections': [
      {
        'name': 'Section label',
        'index': 0,
        'questions': [
          {
            'label': 'Question label',
            'question_type': 'RADIO',
            'required': true,
            'index': 0,
            'possibilities': [
              {
                'question_id': 'string',
                'label': 'Option',
                'index': 0,
                'weight': 0
              }
            ]
          }
        ]
      }
    ]
  }
}
